import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { SearchBox } from '../Common/SearchBox';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import AffiliatorLinks from '../../Models/AffiliatorLinks';
import Affiliator from '../../Models/Affiliator';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class AffiliateManagement extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert('ログインしてください')
            window.location.href = '/login/affiliator';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            children: [],
            user: logged_user,
            searchkey: ''
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    componentWillMount() {
        AffiliatorLinks.getChildrenList(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ children: res.data.payload })
            }
        })
    }
    handleSubmit(e) {
        e.preventDefault()
        let data = {
            'searchkey': this.state.searchkey,
            'aff': this.state.user.id
        }
        Affiliator.sendAffiliatorSearch(data).then(res => {
            if (res.data.status === 200) {
                this.setState({ children: res.data.payload })
            }
        })
    }

    showData(id, total, first_name) {
        if (total > 0) {
            return (
                <tr>
                    <td className="" style={{ width: "45%", textAlign: "left", paddingLeft: "10%" }}>
                        {first_name}
                    </td>
                    <td style={{ width: '25%', textAlign: "left", paddingLeft: "10%" }}>
                        <Link to={{
                            pathname: `/affiliator-management-of-child/${id}`,
                            state: { id: id }
                        }} >
                            {parseInt(total)}
                        </Link>
                    </td>
                </tr>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    {/* <div className="col-md-12 tr_blank_medium mt-5"></div> */}
                    <div className="contaner-fluid">
                        <div className="">
                            {/* <div className="col-md-4 input_name">
                                <AffiliatorSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className=" mt-5 input_name big_font text-left" style={{ width: '100%', fontSize: '20px' }}>
                                    アフィリエイター管理
                                </div>
                                <div className="">
                                    <table className="table_individual  ">
                                        <tbody>
                                            <tr>
                                                <td className="" style={{ width: "45%", textAlign: "left", paddingLeft: "10%" }}>
                                                    <b>ユーザー名</b>
                                                </td>
                                                <td style={{ width: '25%', textAlign: "left", paddingLeft: "10%" }}>
                                                    <b>報酬</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table className="table_individual ">
                                        <tbody>
                                            {this.state.children.map(group =>
                                                this.showData(group.id, group.total, group.first_name)
                                            )}
                                        </tbody>
                                    </table>
                                    <ToastContainer />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div><br /><br /></div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="contaner-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" mb-1 input_name big_font text-left" style={{ width: '100%',fontSize:'20px' }}>
                                            アフィリエイター管理
                                    </div>
                                        <div className="row">
                                            <table className="table_individual  ml-3">
                                                <tbody>
                                                    <tr>
                                                        <td className="" style={{ width: "45%", textAlign: "left", paddingLeft: "10%" }}>
                                                            <b>
                                                                ユーザー名
                                                        </b>
                                                        </td>
                                                        {/* <td style={{ width: '30%' }}>
                                                        <strong>
                                                            レベル
                                                        </strong>
                                                    </td> */}
                                                        <td style={{ width: '25%', textAlign: "left", paddingLeft: "10%" }}>
                                                            <b>
                                                                報酬
                                                        </b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {/* {(() => {
                                            if (this.state.children.length === 0) {
                                                return (
                                                    <div>まだ商品をアップロードしていません!</div>
                                                )
                                            } else {
                                                return ( */}

                                            <table className="table_individual ml-3">
                                                <tbody>
                                                    {this.state.children.map(group =>
                                                        this.showData(group.id, group.total, group.first_name)

                                                    )}
                                                </tbody>
                                            </table>
                                            {/* )
                                            }
                                        })()} */}
                                            <ToastContainer />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div><br /><br /><br /></div>
                    <Footer />
                </div>
            )
        }
    }
}
export { AffiliateManagement }